var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6397 11.5578C18.5175 11.5578 20.0397 10.0356 20.0397 8.15781C20.0397 6.28004 18.5175 4.75781 16.6397 4.75781C14.762 4.75781 13.2397 6.28004 13.2397 8.15781C13.2397 10.0356 14.762 11.5578 16.6397 11.5578Z",
    fill: "#769DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6608 16.8774C22.6608 18.1394 20.1036 19.6925 16.5872 19.6925C13.0707 19.6925 10.2188 18.3874 10.2188 16.8774C10.2188 15.3675 13.0707 12.9946 16.5872 12.9946C20.1036 12.9946 22.6608 15.3135 22.6608 16.8774Z",
    fill: "#769DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6998 11.5578C9.57757 11.5578 11.0998 10.0356 11.0998 8.15781C11.0998 6.28004 9.57757 4.75781 7.6998 4.75781C5.82204 4.75781 4.2998 6.28004 4.2998 8.15781C4.2998 10.0356 5.82204 11.5578 7.6998 11.5578Z",
    fill: "#769DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4495 13.8409C10.4495 13.8409 10.5235 13.7668 10.513 13.7139C10.513 13.661 10.4706 13.6187 10.4177 13.5976C9.51833 13.3224 8.43905 13.2378 7.44443 13.2378C3.66696 13.2378 1.33911 15.3752 1.33911 16.9094C1.33911 18.0734 3.65638 19.6923 7.44443 19.6923C8.36499 19.6923 9.27496 19.6076 10.1532 19.4278C10.2061 19.4278 10.2484 19.3749 10.259 19.3219C10.259 19.269 10.2378 19.2161 10.1955 19.1844C8.89404 18.4543 8.39673 17.8617 8.3544 17.0047C8.28034 15.4387 9.5924 14.3171 10.4389 13.8409H10.4495Z",
    fill: "#769DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/icon_team.06a30a83f571a2333972340cdb973a3c.svg";
export { ForwardRef as ReactComponent };